var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "autocomplete-input form-group position-relative" },
    [
      _vm.label
        ? _c("label", { attrs: { for: _vm.id } }, [_vm._v(_vm._s(_vm.label))])
        : _vm._e(),
      _vm._v(" "),
      _c("input", {
        ref: "input",
        staticClass: "form-control",
        attrs: {
          id: _vm.id,
          "aria-autocomplete": "list",
          "aria-expanded": _vm.dropdownVisible ? "true" : "false",
          "aria-invalid": Boolean(_vm.errorToShow),
          autocomplete: _vm.browserAutocomplete,
          disabled: _vm.disabled,
        },
        domProps: { value: _vm.displayValue },
        on: {
          blur: _vm.onBlur,
          focus: _vm.onFocus,
          input: _vm.onInput,
          keydown: [
            function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "down", 40, $event.key, [
                  "Down",
                  "ArrowDown",
                ])
              )
                return null
              $event.preventDefault()
              return _vm.onArrowDown.apply(null, arguments)
            },
            function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              )
                return null
              $event.preventDefault()
              return _vm.onEnter.apply(null, arguments)
            },
            function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])
              )
                return null
              $event.preventDefault()
              return _vm.closeList.apply(null, arguments)
            },
            function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])
              )
                return null
              $event.preventDefault()
              return _vm.onArrowUp.apply(null, arguments)
            },
          ],
        },
      }),
      _vm._v(" "),
      _vm.dropdownVisible
        ? _c(
            "div",
            {
              staticClass: "list-group position-absolute w-100 shadow-sm",
              staticStyle: { "z-index": "1000" },
            },
            [
              !_vm.pending && !_vm.loading
                ? _c(
                    "div",
                    _vm._l(_vm.options, function (optionItem, optionIndex) {
                      return _c(
                        "div",
                        {
                          key: optionItem.value + ":" + optionIndex,
                          staticClass: "list-group-item list-group-item-action",
                          class: { active: optionIndex === _vm.activeIndex },
                          on: {
                            mousedown: function ($event) {
                              $event.preventDefault()
                              return _vm.choose(optionItem)
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(optionItem.text) +
                              "\n            "
                          ),
                        ]
                      )
                    }),
                    0
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.pending || _vm.loading
                ? _c("div", { staticClass: "list-group-item text-muted" }, [
                    _vm._v("\n            Lädt ...\n        "),
                  ])
                : _vm.searched && _vm.options.length === 0
                ? _c("div", { staticClass: "list-group-item text-muted" }, [
                    _vm._v(
                      "\n            Keine Übereinstimmungen gefunden.\n        "
                    ),
                  ])
                : _vm._e(),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.errorToShow
        ? _c("div", { staticClass: "text-danger mt-1" }, [
            _vm._v("\n        " + _vm._s(_vm.errorToShow) + "\n    "),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }